import {
  initSimpleappRuntime,
  type SimpleappRuntimeIdentity,
} from "@sapps/simpleapp-runtime";

export function initSimpleappRuntimeSafely(
  identity?: SimpleappRuntimeIdentity,
): void {
  if (typeof Storage === "undefined" || typeof window === "undefined") {
    initSimpleappRuntime(identity);
    return;
  }

  const nativeWebSocket = window.WebSocket;
  const nativeWebSocketSend = nativeWebSocket.prototype.send;
  const nativeFetch = window.fetch;
  const nativeXmlHttpRequest = window.XMLHttpRequest;
  const nativeXmlHttpRequestOpen = nativeXmlHttpRequest?.prototype.open;
  const nativeXmlHttpRequestSend = nativeXmlHttpRequest?.prototype.send;
  const nativeEventSource = window.EventSource;
  const nativeSetItem = Storage.prototype.setItem;
  const nativeRemoveItem = Storage.prototype.removeItem;
  const nativeClear = Storage.prototype.clear;

  try {
    initSimpleappRuntime(identity);
  } finally {
    window.WebSocket = nativeWebSocket;
    nativeWebSocket.prototype.send = nativeWebSocketSend;
    window.fetch = nativeFetch;
    if (nativeXmlHttpRequest && nativeXmlHttpRequestOpen && nativeXmlHttpRequestSend) {
      nativeXmlHttpRequest.prototype.open = nativeXmlHttpRequestOpen;
      nativeXmlHttpRequest.prototype.send = nativeXmlHttpRequestSend;
    }
    window.EventSource = nativeEventSource;
    Storage.prototype.setItem = nativeSetItem;
    Storage.prototype.removeItem = nativeRemoveItem;
    Storage.prototype.clear = nativeClear;
  }
}
